import { cn } from '@/lib/utils';

/**
 * Motion of the collapsible desktop sidebar, shared by the rail and the logo
 * slot above it so both glide as one piece. Widths, duration and curve are
 * theme tokens (tailwind.config.js: `sidebar`, `sidebar-collapsed`).
 * Class names stay literal so Tailwind finds them.
 */
export const RAIL_WIDTH_TRANSITION =
  'transition-[width] duration-sidebar ease-sidebar motion-reduce:transition-none';

export function railWidth(collapsed: boolean): string {
  return collapsed ? 'w-sidebar-collapsed' : 'w-sidebar';
}

/**
 * Texts leave fast, before the narrowing rail clips them, and come back a
 * beat late, once the rail has made room — no half-cut words mid-glide.
 */
export function railFade(hidden: boolean): string {
  return cn(
    'transition-opacity motion-reduce:transition-none',
    hidden ? 'opacity-0 duration-100' : 'opacity-100 duration-200 delay-75',
  );
}
